export const UPDATE_GIFT_OPTIONS = '/EventGifting/*/Update';
export const UPDATE_PLEDGELING_OPTIONS = '/EventGifting/*/Update/Pledgeling';
